var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0625 0.75C22.5703 0.75 23 1.17969 23 1.6875V2.625V16.375V17.3125C23 17.8594 22.5703 18.25 22.0625 18.25C21.5156 18.25 21.125 17.8594 21.125 17.3125V17.1172L14.1719 15.2031C13.8594 16.9609 12.2969 18.25 10.5 18.25C8.42969 18.25 6.75 16.5703 6.75 14.5C6.75 14.0703 6.82812 13.6406 6.94531 13.25L2.375 12V12.3125C2.375 12.8594 1.94531 13.25 1.4375 13.25C0.890625 13.25 0.5 12.8594 0.5 12.3125V11.4922V10.75V8.25V7.54688V6.6875C0.5 6.17969 0.890625 5.75 1.4375 5.75C1.94531 5.75 2.375 6.17969 2.375 6.6875V7.03906L21.125 1.92188V1.6875C21.125 1.17969 21.5156 0.75 22.0625 0.75ZM21.125 15.1641V3.875L2.375 8.99219V10.0469L21.125 15.1641ZM8.625 14.5C8.625 15.5547 9.44531 16.375 10.5 16.375C11.4375 16.375 12.2578 15.6719 12.3359 14.7344L8.78125 13.7578C8.66406 13.9922 8.625 14.2266 8.625 14.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default ForwardRef;